import React, { useEffect, useState } from 'react';
import { BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { Select } from 'antd';
import { useHistory } from 'react-router-dom';

import { saveOnBoardData, finishBoarding } from 'api/onBoarding';
import APFormGroup from 'components/FormFields/APFormGroup';
import FormItem from 'components/FormFields/FormItem';
import { CURRENCIES, DATE_FORMATS, TIME_FORMATS, SURVERY_OPTIONS, SURVERY_EVENTS_OPTIONS } from 'utils/constants';
import { styledTheme } from 'globalStyles/theme';
import { getPutFormat } from './filter';
import './styles.scss';

const { Option } = Select;
const dropdownPlacement = {
  points: ['tl', 'bl'],
  offset: [0, 1],
  overflow: {
    adjustX: 0,
    adjustY: 1,
  },
};

const Step6 = ({ formData }) => {
  const history = useHistory();

  const [isSubmitted, setFormSubmitted] = useState(false);
  const [currency, setCurrency] = useState('USD');
  const [dateFormat, setDateFormat] = useState('mm/dd/yyyy');
  const [timeFormat, setTimeFormat] = useState('12hour');
  const [surveyOption, setSurveyOption] = useState(null);
  const [surveyEventsOption, setSurveyEventsOption] = useState(null);

  useEffect(() => {
    const { preferences } = formData;
    if (preferences) {
      setCurrency(preferences.currency || 'USD');
      setDateFormat(preferences.dateFormat?.toLowerCase() || 'mm/dd/yyyy');
      setTimeFormat(preferences.timeFormat || '12hour');
      setSurveyOption(preferences.hear_about_us || null);
      setSurveyEventsOption(preferences.number_of_events || null);
    }
  }, [formData]);

  const saveForms = async () => {
    const newFormData = formData;
    newFormData.preferences.currency = currency;
    newFormData.preferences.dateFormat = dateFormat;
    newFormData.preferences.timeFormat = timeFormat;
    newFormData.preferences.hear_about_us = surveyOption;
    newFormData.preferences.number_of_events = surveyEventsOption;

    return saveOnBoardData({ boarding: getPutFormat(newFormData) });
  };

  const handleBack = () => {
    history.push('/app/v2/account-setup/step/5');
  };

  const handleNext = async () => {
    setFormSubmitted(true);
    if (!!surveyOption && !!surveyEventsOption) {
      const isSaved = await saveForms();
      if (isSaved) {
        const isSuccess = await finishBoarding();
        if (isSuccess)
          window.location.href = `/app/pro/${formData.companyInfo.orgId}/welcome`;
      }
    }
  };

  return (
    <>
      <section className="stepflow_content">
        <article className="stepflow_form">
          <section className="stepflow_form-header">
            <h3 className="form-title">Account preferences</h3>
            <p className="form-subtitle text-center"
              style={{ width: '100%' }}
            >
              Let’s set your default preferences. You can always change these in your business settings,
              and adjust your preferences for each project.
            </p>
          </section>
          <APFormGroup
            gridGap={1}
          >
            <FormItem
              id="currency"
              name="Currency"
            >
              <Select
                id="currency"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                bordered={false}
                className="account-preference-selector"
                popupClassName="currency-selector-dropdown stepflow_form__selector"
                defaultValue="USD"
                value={currency}
                onChange={(value) => {
                  setCurrency(value);
                }}
                suffixIcon={<MdKeyboardArrowDown size={20} />}
                style={{
                  width: '-webkit-fill-available',
                }}
                dropdownAlign={dropdownPlacement}
              >
                {CURRENCIES.map((option, index) => (
                  <Option value={option.value}
                    key={`option_${  index}`}
                  >
                    {option.label}
                  </Option>
                ))}
              </Select>
            </FormItem>
            <FormItem
              id="date-format"
              name="Date format"
            >
              <Select
                id="date-format"
                bordered={false}
                className="account-preference-selector"
                popupClassName="selector-dropdown stepflow_form__selector"
                defaultValue={DATE_FORMATS[0].value}
                value={dateFormat}
                onChange={(value) => {
                  setDateFormat(value);
                }}
                suffixIcon={<MdKeyboardArrowDown size={20} />}
                style={{
                  width: '-webkit-fill-available',
                }}
                dropdownAlign={dropdownPlacement}
              >
                {DATE_FORMATS.map((option, index) => (
                  <Option value={option.value}
                    key={`option_${  index}`}
                  >
                    {option.label}
                  </Option>
                ))}
              </Select>
            </FormItem>
            <FormItem
              id="time-format"
              name="Time Format"
            >
              <Select
                id="time-format"
                bordered={false}
                className="account-preference-selector"
                popupClassName="selector-dropdown stepflow_form__selector"
                defaultValue="12Hours"
                value={timeFormat}
                onChange={(value) => {
                  setTimeFormat(value);
                }}
                suffixIcon={<MdKeyboardArrowDown size={20} />}
                style={{
                  width: '-webkit-fill-available',
                }}
                dropdownAlign={dropdownPlacement}
              >
                {TIME_FORMATS.map((option, index) => (
                  <Option value={option.value}
                    key={`option_${  index}`}
                  >
                    {option.label}
                  </Option>
                ))}
              </Select>
            </FormItem>
          </APFormGroup>
        </article>
        <article className="stepflow_form stepflow-last-question">
          <section className="stepflow_form-header">
            <h3 className="form-title">Two more questions</h3>
          </section>
          <APFormGroup
            verticalGap={0}
          >
            <FormItem
              id="events-planned"
              name="Avg # of events planned per year?"
              className="form-item--w-30"
              labelProps={{
                className: 'no-wrap',
              }}
              required
            >
              <Select
                id="events-planned"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                bordered={false}
                className="account-preference-selector"
                popupClassName="selector-dropdown stepflow_form__selector"
                placeholder="Select..."
                value={surveyEventsOption}
                onChange={(value) => {
                  setFormSubmitted(false);
                  setSurveyEventsOption(value);
                }}
                virtual={false}
                suffixIcon={<MdKeyboardArrowDown size={20} />}
                style={{
                  width: '-webkit-fill-available',
                  border: '1px solid transparent',
                  borderColor: isSubmitted && !surveyEventsOption ? styledTheme.errorColor : 'transparent',
                }}
                dropdownAlign={dropdownPlacement}
              >
                {SURVERY_EVENTS_OPTIONS.map((option, index) => (
                  <Option value={option.value}
                    key={`option_${index}`}
                  >
                    {option.label}
                  </Option>
                ))}
              </Select>
            </FormItem>
          </APFormGroup>
          <APFormGroup
            verticalGap={0}
          >
            <FormItem
              id="how-heard"
              name="How did you first hear about us?"
              className="form-item--w-30"
              labelProps={{
                className: 'no-wrap',
              }}
              required
            >
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                bordered={false}
                className="account-preference-selector"
                popupClassName="currency-selector-dropdown stepflow_form__selector"
                placeholder="Select..."
                value={surveyOption}
                onChange={(value) => {
                  setFormSubmitted(false);
                  setSurveyOption(value);
                }}
                virtual={false}
                suffixIcon={<MdKeyboardArrowDown size={20} />}
                style={{
                  width: '-webkit-fill-available',
                  border: '1px solid transparent',
                  borderColor: isSubmitted && !surveyOption ? styledTheme.errorColor : 'transparent',
                }}
                dropdownAlign={dropdownPlacement}
              >
                {SURVERY_OPTIONS.map((option, index) => (
                  <Option value={option.value}
                    key={`option_${index}`}
                  >
                    {option.label}
                  </Option>
                ))}
              </Select>
            </FormItem>
          </APFormGroup>
        </article>
      </section>
      <section className="stepflow_footer">
        <button className="stepflow_footer-button"
          onClick={handleBack}
        >
          <BsArrowLeftShort size={20} /> Back
        </button>
        {isSubmitted && !surveyOption && (
          <div className="stepflow_footer-error">
            Please complete required fields above.
          </div>
        )}
        <button
          className="stepflow_footer-button"
          color="primary"
          onClick={handleNext}
        >
          Finish
          <BsArrowRightShort size={20} />
        </button>
      </section>
    </>
  );
};

export default Step6;
